import { createContext, useContext } from 'react';

import type { TemplateOperationContext } from './types';

export type TemplateOperationExtras = Pick<
  TemplateOperationContext,
  'templateId' | 'toolName' | 'onOperationComplete' | 'redeemSavedVersionRestore'
>;

const TemplateOperationExtrasContext = createContext<TemplateOperationExtras>({});

TemplateOperationExtrasContext.displayName = 'TemplateOperationExtrasContext';

export const TemplateOperationExtrasProvider = TemplateOperationExtrasContext.Provider;

export function useTemplateOperationExtras(): TemplateOperationExtras {
  return useContext(TemplateOperationExtrasContext);
}
